module.exports = __webpack_public_path__ + "img/mermaid-tail.e84b966d.jpg";